export enum FreekickOutcome {
    FreeKickFor = 1,
    FreeKickAgainst = 2
}